<script setup lang="ts">
import usePixabayDialog from "@/stories/dialogs/imageDialogs/pixabay/usePixabayDialog";
import TextInput from "@/stories/form/TextInput/TextInput.vue";
import { debounce } from "lodash";
import Button from "@/stories/buttons/Button/Button.vue";
import type { IFileState } from "@/interfaces";
import converters from "@/converters";

const emit = defineEmits<{ "update:images": [IFileState[]] }>();

const dialog = usePixabayDialog();

const fetchImages = async () => {
  const result = await dialog.fetchImages();
  if (result) {
    emit("update:images", converters.pixabay.toFileState(result));
  }
};

const updateSearchText = async () => {
  dialog.searchResult.value = [];
  dialog.page.value = 1;
  dialog.selectedImages.value = [];
  await fetchImages();
};

const debouncedUpdateSearchText = debounce(updateSearchText, 300);

const handleSearchUpdate = (value: string) => {
  dialog.searchText.value = value;
  debouncedUpdateSearchText();
};
</script>

<template>
  <form
    @submit.prevent="fetchImages"
    class="flex justify-between items-center gap-4 w-full"
  >
    <TextInput
      name="search"
      rounded
      size="sm"
      icon="fas-magnifying-glass"
      background="bg-neutral100"
      :placeholder="$t('templates.search_image')"
      :helpText="
        !dialog.searchText.value.length &&
        dialog.searchResult.value.length === 0
          ? $t('templates.pixabay.search_help_text')
          : undefined
      "
      autoFocus
      :modelValue="dialog.searchText.value"
      @update:modelValue="handleSearchUpdate"
    />

    <Button
      iconOnly
      icon="far-magnifying-glass"
      iconClass="1.5rem min-w-10"
      type="white"
      :buttonType="'submit'"
    />
  </form>
</template>
